/* eslint-disable arrow-body-style */
import React from 'react';
// import moment from 'moment';
import MultipleLinesTextBubble from '@gp/components/MultipleLinesTextBubble';
// @ts-ignore
import ProjectItem from '@gp/pages/Pipeline/Project/components/ProjectList/ProjectItem';
import TextAreaMore from '@gp/components/TextAreaMore';
import { getRangeIdElementWithAuth } from '../../../../../../../Details/components/Development/components/Overview/components/Table/utils/common';
import {
  isIncludeConsole,
  // getProgressTagHoverMsg,
  // getFormatNumPlus,
  // toFirstUpperCase,
  queryJumpable,
  synchonizeProjectUpdateFieldsDiff,
  // formatDateStr,
} from '@gp/utils/common';
import { ProjectPriority } from '@gp/enums/project';
import {
  // PROGRESS_ENUM,
  PRIORITY_COLOR,
  // PROGRESS_TEXT_COLOR,
  MENU_ID_MAP,
  SLASH_G_POP,
} from '@gp/constants/const';
// @ts-ignore
// import ProgressTag from '@gp/components/ProgressTag';
import InfoBubble from '@gp/components/InfoBubble';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import LinkJump from '@gp/components/LinkJump';
import { history } from 'umi';
import { FIELDS1, FIELD_NAMES } from '@gp/utils/metricTips';
import SvgIcon from '@/pages/home/components/SvgIcon';
// import { PageMode } from '@gp/enums/common';
import {
  renderLaunchDateUI,
  renderNextMilestoneUI,
  renderUpdateUI,
} from '@gp/pages/Pipeline/Project/components/ProjectList/utils/common';
// import { getIsMilestoneTBC } from '@gp/pages/Pipeline/utils';

const toDetail = (studioId: string, studioName: string, isJump = true) => {
  if (!studioId) return '';
  const filter = encodeURIComponent(
    JSON.stringify({
      studioId,
      studioName,
      menuFrom: MENU_ID_MAP['studio-dashboard_studio-overall'], // 用于标识左侧菜单栏当前选中高亮
      tab: 'projects',
    }),
  );
  const url = `${SLASH_G_POP}/Studio/PortfolioOverview/Detail?filter=${filter}`;
  if (isJump) {
    history.push(url);
  }

  return url;
};

/**
 * 获取表格配置项
 */
const getColumns = (
  toDetails: Function,
  setProjectUpdatesVisible: React.Dispatch<React.SetStateAction<boolean>>,
  setProjectUpdatesModalList: React.Dispatch<React.SetStateAction<any>>,
  // openPPS: (pageMode: PageMode, payload: any) => void,
  // ppsViewable?: boolean,
  updatesViewable?: boolean,
  // 是否展示Y1 Forecase Revenue($)列、3Y Forecast Revenue($)列
  salesViewable?: boolean,
) => {
  let _options = [
    {
      key: 'project',
      width: 240,
      header: 'Project',
      fixed: 'left',
      render: (cvm: any) => {
        const { platform } = cvm;
        const platformLowerCase =
          (Array.isArray(platform)
            ? platform.join(',')?.toLowerCase()
            : platform?.trim()?.toLowerCase()) || '';

        return (
          <ProjectItem
            data={cvm}
            toDetails={toDetails}
            bubble={
              <div
                className="globalpedia-modal-font14"
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <span style={{ wordBreak: 'break-all' }}>{cvm.project}</span>
                {/* <ProgressTag progress={cvm.progress} type="GT" /> */}
              </div>
            }
          >
            <div className="dbg-prejects-slot">
              {(platformLowerCase?.toLowerCase() === 'all platforms' ||
                platformLowerCase?.toLowerCase().includes('mobile')) && (
                <SvgIcon type="other-icon" />
              )}
              {(platformLowerCase?.toLowerCase() === 'all platforms' ||
                platformLowerCase?.toLowerCase().includes('pc')) && <SvgIcon type="monitor" />}
              {(platformLowerCase?.toLowerCase() === 'all platforms' ||
                isIncludeConsole(platformLowerCase)) && <SvgIcon type="game" />}
            </div>
          </ProjectItem>
        );
      },
    },
    {
      key: 'studio',
      header: 'Studio',
      align: 'left',
      // fixed: 'left',
      width: 180,
      render: (cvm: any) => {
        return (
          <LinkJump
            // style={{
            //   textDecoration: 'none',
            //   color: '#444',
            //   display: 'flex',
            //   width: '100%',
            // }}
            className="dbg-table-common-text"
            url={toDetail(cvm?.studio_entity_id, cvm?.studio, false)}
          >
            <span
              className="dbg-table-studio-name gp-cursor-pointer"
              onClick={(e) => {
                if (!queryJumpable(e)) return;
                toDetail(cvm?.studio_entity_id, cvm?.studio);
              }}
            >
              <EllipsisTextBubble text={cvm?.studio || '-'} />
            </span>
          </LinkJump>
        );
      },
    },
    {
      key: 'business_owner',
      header: 'BO',
      align: 'left',
      width: 120,
      render: (cvm: any) => {
        let businessOwner = cvm.business_owner || '';
        try {
          businessOwner = Object.values(JSON.parse(cvm.business_owner))[0] || businessOwner;
        } catch (error) {
          // console.warn(error);
        }
        return <div className="gp-word-break-word">{businessOwner || '-'}</div>;
      },
    },
    {
      key: 'genre',
      header: 'Genre',
      align: 'left',
      width: 120,
      render: (cvm: any) => {
        return (
          <InfoBubble
            className="globalpedia-modal-font14"
            customBubbleContent={
              <>
                <section className="bubble-genre">
                  Genre: {cvm?.genre?.replaceAll(/[;||]/g, ', ') || '-'}
                </section>
                <section className="bubble-sub-genre">
                  Sub Genre: {cvm?.expanded_genre?.replaceAll(/[;||]/g, ', ') || '-'}
                </section>
              </>
            }
            DomOrText={
              <span className="gp-word-break-word">
                {cvm?.genre?.replaceAll(/[;||]/g, ', ') || '-'}
              </span>
            }
          />
        );
      },
    },
    // {
    //   key: 'priority',
    //   width: 120,
    //   header: 'Priority',
    //   render: (cvm: any) => {
    //     return (
    //       <>
    //         <div
    //           style={{
    //             width: '4px',
    //             height: '12px',
    //             borderRadius: '2px',
    //             background: (PRIORITY_COLOR as any)?.[cvm.priority],
    //             display: 'inline-block',
    //             marginRight: '4px',
    //             verticalAlign: 'middle',
    //           }}
    //         ></div>
    //         {cvm.priority ? (ProjectPriority as any)?.[cvm.priority] || '' : ''}
    //       </>
    //     );
    //   },
    // },
    {
      key: 'launch_date',
      width: 148,
      header: 'Launch Time',
      render: (cvm: any) => {
        // const renderReviewUI = () => {
        //   if (!cvm?.launch_date) return '-';
        //   const date = moment(cvm.launch_date).format('YYYY-MM-DD');
        //   const isTBC = getIsMilestoneTBC(cvm);
        //   return (
        //     <InfoBubble
        //       DomOrText={date}
        //       customBubbleContent={!isTBC ? undefined :
        //         <div style={{ lineHeight: '22px', fontSize: 14 }}>
        //           <div style={{ marginBottom: 4 }}>Launch Date</div>
        //           <div>
        //             <span>{date}</span>
        //             <span style={{ marginLeft: 10 }}>(To Be Confirmed)</span>
        //           </div>
        //         </div>
        //       }
        //     />
        //   );
        // };

        // return renderReviewUI();

        return renderLaunchDateUI(cvm);
      },
    },
    // {
    //   key: 'progress',
    //   width: 160,
    //   header: (<span>Progress</span>),
    //   render: (cvm: any) => {
    //     let res: any = '-';
    //     let progress = cvm?.progress;
    //     let delay = cvm?.delay;
    //     if (PROGRESS_ENUM[progress]) {
    //       /**
    //        * On Track状态 delay为0，或者 Not Start状态时，不需要hover气泡提示
    //        * 其余状态有对应hover气泡提示
    //        */
    //       const bubbleInfo = getProgressTagHoverMsg(progress, delay);
    //       res = (
    //         <InfoBubble
    //           className="globalpedia-modal-font14"
    //           DomOrText={(<ProgressTag className="gp-all-projects-progress-tag" progress={progress} />)}
    //           customBubbleContent={
    //             (!['5', 5]?.includes(progress) && bubbleInfo) ? (<span style={{fontSize: 14}}>{bubbleInfo}</span>) : undefined
    //           }
    //         />
    //       );
    //     } else {
    //       res = '-';
    //     }

    //     return res;
    //   },
    // },
    // {
    //   key: 'status',
    //   width: 160,
    //   header: (<span>Status</span>),
    //   render: (cvm: any) => {
    //     const ppsReviewable = cvm?.pps_comment?.view_pps;
    //     if (!ppsReviewable) return '-';
    //     let res: any = '-';
    //     let status = cvm?.pps_comment?.list?.[0]?.status;
    //     let delay = cvm?.delay;
    //     if (PROGRESS_ENUM[status]) {
    //       /**
    //        * On Track状态 delay为0，或者 Not Start状态时，不需要hover气泡提示
    //        * 其余状态有对应hover气泡提示
    //        */
    //       const bubbleInfo = getProgressTagHoverMsg(status, delay);
    //       res = (
    //         <InfoBubble
    //           className="globalpedia-modal-font14"
    //           DomOrText={(<ProgressTag className="gp-all-projects-progress-tag" progress={status} />)}
    //           customBubbleContent={
    //             (!['5', 5]?.includes(status) && bubbleInfo) ? (<span style={{fontSize: 14}}>{bubbleInfo}</span>) : undefined
    //           }
    //         />
    //       );
    //     } else {
    //       res = '-';
    //     }

    //     return res;
    //   },
    // },
    // {
    //   key: 'pps_comment',
    //   header: 'DPS Comment',
    //   width: 300,
    //   render: (cvm: any) => {
    //     const ppsReviewable = cvm?.pps_comment?.view_pps;
    //     if (!ppsReviewable) return '-';
    //     const ppsData = cvm?.pps_comment || {};
    //     const richText = ppsData?.list?.[0]?.comment || '';

    //     return (
    //       <div>
    //         <TextAreaMore
    //           className="gp-word-break-word gp-all-dom-line-height-24 gp-text-area-more float-btn-left gp-inital-list-style"
    //           type="shadow"
    //           shadowInitBoxShowH={144}
    //           lineHeight={24}
    //           isShadowLayer={false}
    //           isMustButton={!!richText}
    //           unfoldButtonText="Details"
    //           foldButtonText="Details"
    //           text={richText || '-'}
    //           isShowAllContent={false}
    //           onClick={() => {
    //             const ppsData = cvm?.pps_comment || {};
    //             const ppsModalData = { ...ppsData };
    //             openPPS?.(PageMode.Review, ppsModalData);
    //           }}
    //         />
    //       </div>
    //     );
    //   },
    // },
    {
      key: 'key_updates',
      width: 300,
      header: 'Project Updates',
      render: (cvm: any) => {
        if (!cvm?.updates_info?.view_update) return '-';
        const richText = cvm?.updates_info?.content?.key_updates;

        return (
          <div>
            <TextAreaMore
              className="gp-word-break-word gp-all-dom-line-height-24 gp-text-area-more float-btn-left gp-inital-list-style dbg-rich-text-editor-content"
              type="shadow"
              shadowInitBoxShowH={144}
              lineHeight={24}
              isShadowLayer={false}
              isMustButton={!!richText}
              unfoldButtonText="Details"
              foldButtonText="Details"
              text={richText || '-'}
              isShowAllContent={false}
              onClick={() => {
                const projectUpdate = synchonizeProjectUpdateFieldsDiff(cvm?.updates_info);
                setProjectUpdatesVisible(true);
                setProjectUpdatesModalList(projectUpdate);
              }}
            />
          </div>
        );
      },
    },
    {
      key: 'next_checkpoint',
      width: 190,
      header: 'Next Milestone',
      render: (cvm: any) => renderNextMilestoneUI(cvm),
    },
    {
      key: 'y1_revenue',
      width: 160,
      align: 'right',
      header: (
        <MultipleLinesTextBubble
          fields={FIELDS1}
          names={FIELD_NAMES}
          data={{
            definition: 'Forecast of total sales amount of product over the first 12 months.',
            source: 'Gate Review Documents',
            updateCadence: 'Ad hoc, after Gate Reviews',
          }}
        >
          <div className="dbg-table-header-text">
            1Y Forecast
            <br />
            Revenue($)
          </div>
        </MultipleLinesTextBubble>
      ),
      render: (cvm: any) => getRangeIdElementWithAuth('y1_sales', cvm),
    },
    {
      key: 'y3_revenue',
      width: 160,
      align: 'right',
      header: (
        <MultipleLinesTextBubble
          fields={FIELDS1}
          names={FIELD_NAMES}
          data={{
            definition: 'Forecast of total sales amount of product over the first three years.',
            source: 'Gate Review Documents',
            updateCadence: 'Ad hoc, after Gate Reviews',
          }}
        >
          <div className="dbg-table-header-text">
            3Y Forecast
            <br />
            Revenue($)
          </div>
        </MultipleLinesTextBubble>
      ),
      render: (cvm: any) => getRangeIdElementWithAuth('y3_sales', cvm),
    },
    {
      key: 'update_time',
      width: 240,
      align: 'left',
      header: 'Update Time',
      render: (cvm: any) => renderUpdateUI(cvm),
      // render: (cvm: any) => {
      //   const time = formatDateStr(cvm?.max_update_time?.update_time) || '-';

      //   return (
      //     <UpdateTimeBubble
      //       updateTime={time}
      //       updatePage={toFirstUpperCase(cvm?.max_update_time?.page) || '-'}
      //       updatedUserName={cvm?.max_update_time?.update_user}
      //       content={<section className="gp-word-break-word">{time}</section>}
      //     />
      //   );
      // },
    },
  ];

  /* if (!ppsViewable) {
    _options = _options?.filter((t: any) => !['status', 'pps_comment'].includes(t?.key));
  } */
  if (!updatesViewable) {
    _options = _options?.filter((t: any) => !['key_updates'].includes(t?.key));
  }

  if (!salesViewable) {
    _options = _options?.filter((t: any) => !['y1_revenue', 'y3_revenue'].includes(t?.key));
  }

  return _options;
};

export { getColumns };
